import { sellerCustomerCareAPI } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

export function useFormatIssues(issues: Array<sellerCustomerCareAPI.Issue>) {
  const i18n = useI18n()

  const issuesLabels = issues.map((issue: sellerCustomerCareAPI.Issue) =>
    issue.translationKey === null
      ? issue.type
      : i18n({ id: issue.translationKey, defaultMessage: '' }),
  )

  return issuesLabels.join(', ')
}
